export { default } from './ScannedSectionsContent';
